<template>
  <div class="revenue-client-report">
    <h3>Revenue Client Report</h3>

    <div class="w-50 mb-3">
      <Tabs 
          :tabSelected="tabSelected" 
          :tabs="tabs" 
          @change="changeTab($event)" 
      />
    </div>

    <div class="col-md-12 px-0 mb-3">
      <div class="container-fluid w-100 mb-0 p-3 border bg-white rounded stats-wrapper">
        <div class="d-flex flex-wrap">
          <div class="w-25 input-group input-group-sm p-1">
            <div class="input-group-prepend">
              <span class="input-group-text" id="inputGroup-sizing-sm">Date</span>
            </div>
            <date-picker id="startDatePicker" class="form-control" v-model="filterMonth" :config="datePickerConfig"
              placeholder="Start Date"></date-picker>
          </div>

          <div class="w-25 input-group input-group-sm p-1">
            <div class="input-group-prepend">
              <span class="input-group-text" id="inputGroup-sizing-sm">Account Manager</span>
            </div>
            <select name="" id="" class="form-control" v-model="userOliverSale">
              <option v-for="sale in userOliverSales" :key="sale.id" :value="sale.id">{{ sale.label }}</option>
            </select>
          </div>

          <div class="w-25 input-group input-group-sm p-1">
            <div class="input-group-prepend">
              <span class="input-group-text" id="inputGroup-sizing-sm">Client Type</span>
            </div>
            <select name="" id="" class="form-control" v-model="subscriptionStatus">
              <option value="0">All</option>
              <option value="1">Subscribed</option>
              <option value="2">Non-Subscribed</option>
            </select>
          </div>

          <button class="btn btn-success" @click="loadReportData()" :disabled="loading" style="width: 25%">
            <i class="icon-calendar-check-o mr-2"></i>
            <small>Filter</small>
          </button>
        </div>
      </div>
    </div>

    <div v-if="loading" class="d-flex align-items-center justify-content-center p-5">
      <LoadingSpinner></LoadingSpinner>
    </div>

    <div v-else-if="reportData.length === 0" class="alert alert-info">
      No data available
    </div>

    <div v-else class="col-md-12 px-0 mx-0 table-sticky table-sticky-2col" ref="tableContainer">
      <div class="d-flex align-items-center mb-4 px-2">
        <strong>{{ reportData.length }}</strong>
        <span class="ml-1">results</span>
        <button class="ml-2 btn btn-sm btn-primary" @click="download()">
          Download csv
        </button>
      </div>
      <button class="btn-top" @click="scrollToTop($refs.tableContainer)"><span class="arrow up"></span></button>
      <button class="btn-bottom" @click="scrollToBottom($refs.tableContainer)"><span class="arrow down"></span></button>
      <Table class="mx-2 w-100" :headers="headers" :cols="cols" :data="tableData" :checkbox="false" :notselect="true"
        :model="model" @openClient="openClient" />
    </div>
  </div>
</template>

<script>
import { clientsService, usersService } from "@/_services";
import LoadingSpinner from "@/components/LoadingSpinner.vue";
import Table from "@/components/Common/Table.vue";
import Tabs from "@/components/Common/Tabs.vue";
import IndustrySearch from "@/components/AccountCreation/Steps/Campaign/search/IndustrySearch.vue";
import moment from "moment";

export default {
  name: 'RevenueClient',
  components: {
    LoadingSpinner,
    Table,
    Tabs,
    IndustrySearch,
  },
  props: {
  },
  data() {
    return {
      reportData: [],
      currentMonthRankByClientId: {},
      loading: false,
      userOliverSales: [{ id: "0", label: "All" }],
      userOliverSale: "0",
      subscriptionStatus: "0",
      oliverSalesLoaded: false,
      datePickerConfig: {
        format: "YYYY-MMM",
        viewMode: "months",
        minDate: moment().subtract(24, "month"),
        maxDate: moment().endOf("day"),
      },
      filterMonth: moment().format("YYYY-MMM"),
      tabSelected: 1,
      tabs: {
        1: {
          id: 1,
          name: 'All',
          client_status_id: 0,
        },
        2: {
          id: 2,
          name: 'Active',
          client_status_id: 4,
        },
        3: {
          id: 3,
          name: 'Standby',
          client_status_id: 5,
        },
        4: {
          id: 4,
          name: 'Payment Declined',
          client_status_id: 8,
        },
        5: {
          id: 5,
          name: 'Recovery',
          client_status_id: 7,
        },
        6: {
          id: 6,
          name: 'Preparing',
          client_status_id: 3,
        },
      },
      model: {
        imported: false,
        refreshlist: false,
        selectfirst: false,
        cantPerPage: 100,
        currentPage: 1,
      },
      headers: [
        {
          label: "#",
          percentage: "1%",
          class: "overflowhide",

        },
        {
          label: "Client",
          percentage: "10%",
          class: "overflowhide",
          id: 1,
        },
        {
          label: "Status",
          percentage: "10%",
          class: "overflowhide",
          id: 1,
        },
        {
          label: "Client Type",
          percentage: "10%",
          class: "overflowhide",
          id: 1,
        },
        // {
        //   label: "Primary Payment Method",
        //   percentage: "8%",
        //   class: "overflowhide",
        //   id: 1,
        // },
        {
          label: "Account Manager",
          percentage: "10%",
          class: "overflowhide",
          id: 1,
        },
        {
          label: "Service Date",
          percentage: "8%",
          class: "overflowhide",
          id: 2,
        },
        {
          label: "Recurring Revenue",
          percentage: "10%",
          class: "text-left",
          id: 3,
        },
        {
          label: "Leads",
          percentage: "15%",
          class: "overflowhide",
          id: 5,
        },
        {
          label: "Lost revenue",
          percentage: "30%",
          class: "overflowhide",
          id: 6,
        },
        {
          label: "Email Licenses",
          percentage: "8%",
          class: "overflowhide",
          id: 7,
        },
        {
          label: "Domains",
          percentage: "8%",
          class: "overflowhide",
          id: 8,
        },
        {
          label: "Bk Managers Tasks",
          percentage: "10%",
          class: "overflowhide",
          id: 9,
        },
        {
          label: "BK Cold Callers Tasks",
          percentage: "10%",
          class: "overflowhide",
          id: 10,
        },
        {
          label: "Phone Lines",
          percentage: "8%",
          class: "overflowhide",
          id: 11,
        },
        {
          label: "Credits",
          percentage: "15%",
          class: "overflowhide",
          id: 11,
        },
        {
          label: "Total Income",
          percentage: "10%",
          class: "overflowhide",
          id: 12,
        },
        {
          label: "Total Cost",
          percentage: "10%",
          size: "90px",
          class: "text-left",
          id: 13,
        },
        {
          label: "Margin",
          percentage: "10%",
          size: "80px",
          class: "text-left",
          id: 14,
        },
        {
          label: "Margin %",
          percentage: "10%",
          size: "80px",
          class: "text-left",
          id: 15,
        },
        {
          label: "Revenue Share",
          percentage: "10%",
          size: "80px",
          class: "text-left",
          id: 16, 
        },
        {
          label: "Revenue Share Cumul",
          percentage: "10%",
          size: "80px",
          class: "text-left",
          id: 17, 
        },
        {
          label: "Step 1",
          percentage: "8%",
          class: "overflowhide",
          id: 18,
        },
        {
          label: "Total Sent",
          percentage: "8%",
          class: "overflowhide",
          id: 19,
        }
      ],
      cols: [
        [
          {
            type: "twoValueParenthesis",
            format: "rankingRevenueClient",
            value1: "index",
            value2: "current_month_rank",
            value: "index",
            class: "text-primary",
          },
        ],
        [
          {
            value_label: "client",
            value_emit: "client_id",
            class: "text-primary",
            type: "emit",
            emit: "openClient",
          },
        ],
        [
          {
            value: "client_status",
            type: "itemBadge",
            class: "badge badge-pill text-small",
            colors: [
              {
                id: "active",
                label: "Active",
                bgColor: "green",
                textColor: "#FFFFFF",
              },
              {
                id: "standby",
                label: "Stand By",
                bgColor: "gray",
                textColor: "#FFFFFF",
              },
              {
                id: "deleted",
                label: "Deleted",
                bgColor: "red",
                textColor: "#FFFFFF",
              },
              {
                id: "preparing",
                label: "Preparing",
                bgColor: "#ff9800",
                textColor: "#FFFFFF",
              },
              {
                id: "recovery",
                label: "Recovery",
                bgColor: "#dd4b20",
                textColor: "#FFFFFF",
              },
              {
                id: "validation",
                label: "Validation",
                bgColor: "#cf9b20",
                textColor: "#FFFFFF",
              },
              {
                id: "pending-pay",
                label: "Pending Deleted",
                bgColor: "#cf9b20",
                textColor: "#FFFFFF",
              },
            ],
          },
        ],
        [
          {
            value: "subscription_status_id",
            type: "itemBadge",
            class: "badge badge-pill text-small",
            colors: [
              {
                id: 1,
                label: "Subscriber",
                bgColor: "orange",
                textColor: "#FFFFFF",
              },
            ],
          }
        ],
        // [
        //   {
        //     value: "payment_type",
        //     type: "itemBadge",
        //     class: "badge badge-pill text-small",
        //     colors: [
        //       {
        //         id: "credit card",
        //         label: "Credit Card",
        //         bgColor: "blue",
        //         textColor: "#FFFFFF",
        //       },
        //       {
        //         id: "sepa",
        //         label: "SEPA",
        //         bgColor: "green",
        //         textColor: "#FFFFFF",
        //       },
        //       {
        //         id: "another method",
        //         label: "Another Method",
        //         bgColor: "yellow",
        //         textColor: "#000000",
        //       },
        //     ],
        //   }
        // ],
        [
          {
            value: "account_manager",
          },
        ],
        [
          {
            value: "collection_date_formatted",
          },
        ],
        [
          {
            value: "_account_mgmt_fee",
            type: "tinyTotalCols"
          }
        ],
        [
          {
            value: "_leads_fee",
            type: "tinyTotalCols"
          }
        ],
        [
          {
            value: "_lost_revenue",
            type: "tinyTotalCols"
          }
        ],
        [
          {
            value: "email_licenses_cost_formatted",
            type: "tinyTotalCols"
          },
        ],
        [
          {
            value: "domains_cost_formatted",
            type: "tinyTotalCols"
          },
        ],
        [
          {
            value: "total_booker_managers_tasks_formatted",
            type: "tinyTotalCols"
          },
        ],
        [
          {
            value: "total_booker_cold_callers_tasks_formatted",
            type: "tinyTotalCols"
          },
        ],
        [
          {
            value: "total_phone_lines_formatted",
            type: "tinyTotalCols"
          },
        ],
        [
          {
            value: "total_credits_formatted",
            type: "tinyTotalCols"
          },
        ],
        [
          {
            value: "total_formatted",
            type: "tinyTotalCols"
          },
        ],
        [
          {
            value: "total_cost_formatted",
            type: "tinyTotalCols"
          },
        ],
        [
          {
            value: "margin_formatted",
            type: "tinyTotalCols"
          },
        ],
        [
          {
            value: "margin_percentage_formatted",
            type: "tinyTotalCols",
            class: "text-left",
          },
        ],
        [
          {
            value: "revenue_share_formatted",
            type: "tinyTotalCols",
            class: "text-left",
          },
        ],
        [
          {
            value: "revenue_share_cumul_formatted",
            type: "tinyTotalCols",
            class: "text-left",
          },
        ],
        [
          {
            value: "step_1_sent",
            type: "tinyTotalCols",
          },
        ],
        [
          {
            value: "total_emails_sent",
            type: "tinyTotalCols",
          },
        ],
      ],
    };
  },
  computed: {
    filterMonthYm() {
      return moment(this.filterMonth, "YYYY-MMM").format("YYYY-MM");
    },
    tableData() {
      // Formato a la data y agrego fila de totales
      let transformed = this.reportData.map(row => {

        // Formato de data
        const accountMgmtFee = `€ ${this.formatCurrency(row.account_management_fee)} (${(row.account_management_fee_total)})`;
        const businessDevFee = `€ ${this.formatCurrency(row.business_developer_fee)}`;
        const leadsFee = `€ ${this.formatCurrency(row.leads_fee)} (${(row.leads_fee_total)})`;
        const lostRevenue = `€ ${this.formatCurrency(row.lost_revenue)} (${(row.lost_revenue_total)})`;

        const totalIncome = parseFloat(row.total_income) || 0;
        const totalCost = parseFloat(row.total_cost) || 0;
        // Margin % = 1 - (Total Cost / Total Income). Si 0/0 (totalIncome=0) o resultado < 0% → siempre 0%
        let marginPercentage = 0;
        if (totalIncome > 0) {
          const calculated = parseFloat(( (1 - totalCost / totalIncome) * 100 ).toFixed(2));
          marginPercentage = calculated < 0 ? 0 : calculated;
        }
        // Revenue Share = Total Income / Total Income column (this row's share of total income)
        const revenueShare = this.totalIncome > 0
          ? parseFloat( ( (totalIncome / this.totalIncome) * 100 ).toFixed(2) )
          : 0;

        return {
          ...row,
          collection_date_formatted: row.collection_date,
          account_management_fee_formatted: accountMgmtFee,
          business_developer_fee_formatted: businessDevFee,
          leads_fee_formatted: leadsFee,
          total_formatted: `€ ${this.formatCurrency(row.total_income)}`,
          email_licenses_cost_formatted: `€ ${this.formatCurrency(row.email_licenses_cost)} (${(row.email_licenses_cost_total)})`,
          domains_cost_formatted: `€ ${this.formatCurrency(row.domains_cost)} (${(row.domains_cost_total)})`,
          total_booker_managers_tasks_formatted: `€ ${this.formatCurrency(row.booker_managers_tasks)} (${(row.total_booker_managers_tasks)})`,
          total_booker_cold_callers_tasks_formatted: `€ ${this.formatCurrency(row.booker_cold_callers_tasks)} (${(row.total_booker_cold_callers_tasks)})`,
          total_phone_lines_formatted: `€ ${this.formatCurrency(row.phone_lines)} (${(row.total_phone_lines)})`,
          total_credits_formatted: `€ ${this.formatCurrency(row.total_credits)} (${(row.qty_credits)})`,
          total_cost_formatted: `€ ${this.formatCurrency(row.total_cost)}`,
          margin_formatted: `€ ${this.formatCurrency(row.margin)}`,
          margin_percentage: marginPercentage,
          margin_percentage_formatted: this.formatPct(marginPercentage),
          revenue_share: revenueShare,
          revenue_share_formatted: this.formatPct(revenueShare),
          // Store formatted amounts for dynamic label update
          _account_mgmt_fee: accountMgmtFee,
          _business_dev_fee: businessDevFee,
          _leads_fee: leadsFee,
          _lost_revenue: lostRevenue
        };
      });

      // Ordenar por margin de mayor a menor
      transformed.sort((a, b) => parseFloat(b.margin || 0) - parseFloat(a.margin || 0));

      const showRankCompare =
        this.filterMonthYm < moment().format("YYYY-MM");

      transformed = transformed.map((row, index) => {
        const viewedRank = index + 1;
        let current_month_rank = null;
        if (showRankCompare && row.client_id != null && row.client_id !== "") {
          const r = this.currentMonthRankForClient(row.client_id);
          if (r !== undefined) current_month_rank = r;
        }
        return {
          ...row,
          index: viewedRank,
          current_month_rank,
        };
      });

      // Revenue Share Cumul = suma acumulada de la columna Revenue Share (fila 1 + fila 2 + ...)
      // Ej: fila 1 = 3%, fila 2 = 2% → cumul fila 2 = 5% (3+2)
      let revenueShareCumul = 0;
      transformed = transformed.map((row) => {
        if (row.totalRow) return row;
        revenueShareCumul = parseFloat((revenueShareCumul + (row.revenue_share || 0)).toFixed(2));
        return {
          ...row,
          revenue_share_cumul: revenueShareCumul,
          revenue_share_cumul_formatted: this.formatPct(revenueShareCumul)
        };
      });

      // Total Margin % = 1 - (Total Cost / Total Income) con los totales del reporte. Ej: 1 - (34228.26/216379.26) = 84.18%
      let totalMarginPct = 0;
      if (this.totalIncome > 0) {
        const calculated = parseFloat(( (1 - this.totalCost / this.totalIncome) * 100 ).toFixed(2));
        totalMarginPct = calculated < 0 ? 0 : calculated;
      }

      // Agrego fila de totales
      const totalsRow = {
        totalRow: true,
        client: "Total",
        collection_date_formatted: "",
        account_management_fee_formatted: `€ ${this.formatCurrency(this.totalAccountManagement)}`,
        business_developer_fee_formatted: `€ ${this.formatCurrency(this.totalBusinessDeveloper)}`,
        leads_fee_formatted: `€${this.formatCurrency(this.totalLeads)}`,
        lost_revenue_formatted: `€ ${this.formatCurrency(this.totalLostRevenue)}`,
        total_formatted: `€${this.formatCurrency(this.totalGrand)}`,
        email_licenses_cost_formatted: `€ ${this.formatCurrency(this.totalEmailLicenses)}`,
        domains_cost_formatted: `€ ${this.formatCurrency(this.totalDomains)}`,
        total_booker_managers_tasks_formatted: `€ ${this.formatCurrency(this.totalBookerManagersTasks)}`,
        total_booker_cold_callers_tasks_formatted: `€ ${this.formatCurrency(this.totalBookerColdCallersTasks)}`,
        total_phone_lines_formatted: `€ ${this.formatCurrency(this.totalPhoneLines)}`,
        total_cost_formatted: `€ ${this.formatCurrency(this.totalCost)}`,
        margin_formatted: `€ ${this.formatCurrency(this.totalMargin)}`,
        margin_percentage: totalMarginPct,
        margin_percentage_formatted: this.formatPct(totalMarginPct),
        revenue_share: 0,
        revenue_share_formatted: "100.00%",
        revenue_share_cumul: 0,
        revenue_share_cumul_formatted: "100.00%",
        account_management_status: `€ ${this.formatCurrency(this.totalAccountManagement)}`,
        business_developer_status: `€ ${this.formatCurrency(this.totalBusinessDeveloper)}`,
        _leads_fee: `€ ${this.formatCurrency(this.totalLeads)}`,
        _account_mgmt_fee: `€ ${this.formatCurrency(this.totalAccountManagement)}`,
        _lost_revenue: `€ ${this.formatCurrency(this.totalLostRevenue)}`,
        total_credits_formatted: `€ ${this.formatCurrency(this.totalCredits)}`,
        total_formatted: `€ ${this.formatCurrency(this.totalIncome)}`,
        step_1_sent: this.totalStep1Sent,
        total_emails_sent: this.totalEmailsSent,
      };

      return [...transformed, totalsRow];
    },
    totalAccountManagement() {
      return this.reportData.reduce((sum, row) => {
        return sum + parseFloat(Number(row.account_management_fee) || 0);
      }, 0);
    },
    totalBusinessDeveloper() {
      return this.reportData.reduce((sum, row) => {
        return sum + parseFloat(Number(row.business_developer_fee) || 0);
      }, 0);
    },
    totalLeads() {
      return this.reportData.reduce((sum, row) => {
        return sum + parseFloat(Number(row.leads_fee) || 0);
      }, 0);
    },
    totalLostRevenue() {
      return this.reportData.reduce((sum, row) => {
        return sum + parseFloat(Number(row.lost_revenue) || 0);
      }, 0);
    },
    totalGrand() {
      return this.reportData.reduce((sum, row) => {
        return sum + parseFloat(Number(row.total) || 0);
      }, 0);
    },
    totalEmailLicenses() {
      return this.reportData.reduce((sum, row) => {
        return sum + parseFloat(Number(row.email_licenses_cost) || 0);
      }, 0);
    },
    totalDomains() {
      return this.reportData.reduce((sum, row) => {
        return sum + parseFloat(Number(row.domains_cost) || 0);
      }, 0);
    },
    totalBookerManagersTasks() {
      return this.reportData.reduce((sum, row) => {
        return sum + parseFloat(Number(row.booker_managers_tasks) || 0);
      }, 0);
    },
    totalBookerColdCallersTasks() {
      return this.reportData.reduce((sum, row) => {
        return sum + parseFloat(Number(row.booker_cold_callers_tasks) || 0);
      }, 0);
    },
    totalPhoneLines() {
      return this.reportData.reduce((sum, row) => {
        return sum + parseFloat(Number(row.phone_lines) || 0);
      }, 0);
    },
    totalCost() {
      return this.reportData.reduce((sum, row) => {
        return sum + parseFloat(Number(row.total_cost) || 0);
      }, 0);
    },
    totalMargin() {
      return this.reportData.reduce((sum, row) => {
        return sum + parseFloat(Number(row.margin) || 0);
      }, 0);
    },
    totalCredits() {
      return this.reportData.reduce((sum, row) => {
        return sum + parseFloat(Number(row.total_credits) || 0);
      }, 0);
    },
    totalIncome() {
      return this.reportData.reduce((sum, row) => {
        return sum + parseFloat(Number(row.total_income) || 0);
      }, 0);
    },
    totalStep1Sent() {
      return this.reportData.reduce((sum, row) => {
        return sum + (parseInt(row.step_1_sent) || 0);
      }, 0);
    },
    totalEmailsSent() {
      return this.reportData.reduce((sum, row) => {
        return sum + (parseInt(row.total_emails_sent) || 0);
      }, 0);
    }
  },
  methods: {
    download() {
      const nameDocument = "report-revenue-client.csv";

      const splitFields = new Set([
        '_account_mgmt_fee',
        '_leads_fee',
        '_lost_revenue',
        'email_licenses_cost_formatted',
        'domains_cost_formatted',
        'total_booker_managers_tasks_formatted',
        'total_booker_cold_callers_tasks_formatted',
        'total_phone_lines_formatted',
        'total_credits_formatted',
      ]);

      const csvHeaders = [];
      const csvFields = [];

      this.headers.forEach((h, i) => {
        const field = this.cols[i][0].value || this.cols[i][0].value_label;
        csvHeaders.push(h.label);
        csvFields.push({ field, split: false });
        if (splitFields.has(field)) {
          csvHeaders.push(h.label + ' Qty');
          csvFields.push({ field, split: true });
        }
      });

      const rows = this.tableData.map(item => {
        return csvFields.map(({ field, split }) => {
          const raw = item[field];
          const str = String(raw !== undefined && raw !== null ? raw : '');
          if (splitFields.has(field)) {
            const match = str.match(/^(.*?)\s*\(([^)]*)\)\s*$/);
            if (match) {
              return split ? match[2].trim() : match[1].trim();
            }
            return split ? '' : str.trim();
          }
          return str;
        }).map(v => `"${v.replace(/"/g, '""')}"`).join(",");
      });

      const csv = `${csvHeaders.join(",")}\n${rows.join("\n")}`;
      const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
      const url = URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.setAttribute("href", url);
      link.setAttribute("download", nameDocument);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
    changeTab(tabId) {
      if(tabId === this.tabSelected) return;
      this.tabSelected = tabId;
      this.filterMonth = moment().format("YYYY-MMM");
      this.subscriptionStatus = "0";
      this.userOliverSale = "0";
      this.loadReportData();
    },
    openClient(client_id) {
      let url = "/clients/" + client_id;
      window.open(url, "_blank");
    },
    async loadReportData() {
      this.loading = true;
      try {
        const filterD = moment(this.filterMonth, "YYYY-MMM").format("YYYY-MM");
        const currentD = moment().format("YYYY-MM");
        const client_status_id = this.tabs[this.tabSelected].client_status_id;
        const params = {
          yearMonth: filterD,
          client_status_id,
          account_manager: this.userOliverSale,
          subscription_status: this.subscriptionStatus,
        };
        const isPastMonth = filterD < currentD;

        let data;
        let dataCurrentMonth = null;
        if (isPastMonth) {
          const paramsCurrent = { yearMonth: currentD, client_status_id };
          [data, dataCurrentMonth] = await Promise.all([
            clientsService.getReportPaymentClient(params),
            clientsService.getReportPaymentClient(paramsCurrent),
          ]);
          this.currentMonthRankByClientId = this.buildRankMapFromRows(
            dataCurrentMonth || []
          );
        } else {
          data = await clientsService.getReportPaymentClient(params);
          this.currentMonthRankByClientId = {};
        }

        this.reportData = data || [];
      } catch (error) {
        console.error("Error loading report data:", error);
        this.reportData = [];
        this.currentMonthRankByClientId = {};
      } finally {
        this.loading = false;
      }
    },
    /** Ranking 1-based por client_id (mismo criterio que la tabla: margin desc). */
    buildRankMapFromRows(rows) {
      const sorted = [...rows].sort(
        (a, b) => parseFloat(b.margin || 0) - parseFloat(a.margin || 0)
      );
      const map = {};
      sorted.forEach((row, i) => {
        const id = row.client_id;
        if (id != null && id !== "") {
          map[id] = i + 1;
        }
      });
      return map;
    },
    currentMonthRankForClient(clientId) {
      const map = this.currentMonthRankByClientId;
      if (map[clientId] !== undefined) return map[clientId];
      if (map[String(clientId)] !== undefined) return map[String(clientId)];
      return undefined;
    },
    formatCurrency(value) {
      const num = parseFloat(value || 0);
      return num.toFixed(2);
    },
    // Si el valor es 0, null, undefined, NaN o negativo → mostrar "0.00%"
    formatPct(value) {
      if (value == null || value < 0 || Number.isNaN(value)) return "0.00%";
      return parseFloat(value).toFixed(2) + "%";
    },
    getUserOliverSales() {
      this.oliverSalesLoaded = false;
      usersService
        .getUserOliverSales(true, 0, true)
        .then((res) => {
          if (res.result.length > 0) {
            const userOliverSalesWithlabel = res.result.map((el) => ({
              ...el,
              label:  el.name + ", " + el.lastname,
            }));
            this.userOliverSales.push(...userOliverSalesWithlabel);
            this.oliverSalesLoaded = true;
          }
        })
        .catch((err) => console.error(err));
    },
    selectOliverSale(value) {
      const userOliverSaleId = value.id;
      this.userOliverSale = [userOliverSaleId];
    },
  },
  mounted() {
    this.loadReportData();
    this.getUserOliverSales();
  }
};
</script>
